import { render, staticRenderFns } from "./FinanceTabRestaurantPayouts.vue?vue&type=template&id=37deb235&scoped=true"
import script from "./FinanceTabRestaurantPayouts.vue?vue&type=script&lang=js"
export * from "./FinanceTabRestaurantPayouts.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabRestaurantPayouts.vue?vue&type=style&index=0&id=37deb235&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37deb235",
  null
  
)

export default component.exports